export default {"src":"/_next/static/media/meta-switch-icone.ea358981.svg","height":26,"width":90,"blurWidth":0,"blurHeight":0};